/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/sort-comp */
import React from 'react';
import Collection from 'react-virtualized/dist/commonjs/Collection';
import PropTypes from 'prop-types';
import {
    TIME_12H_30_MIN_INTERVALS,
    TIME_24H_30_MIN_INTERVALS
} from 'LocalGluons/components/Epg/utils/constants';
import { formattedTime } from '../../../utils/DateHelpers';

export default class Timeline extends React.PureComponent {
    cellRenderer = ({ index, key, style }) => {
        const hours = this.props.is12HourClock
            ? TIME_12H_30_MIN_INTERVALS
            : TIME_24H_30_MIN_INTERVALS;

        return index === hours.length ? (
            <div key={key}>
                <div
                    style={{
                        ...this.styles.currentTimeLabelContainer,
                        left:
                            this.props.timeLabelPosition -
                            this.props.theme.currentTime.label.width / 2
                    }}
                >
                    <span style={{ ...this.styles.currentTimeLabelText }}>
                        {this.props.currentTimeLabelText ||
                            formattedTime(this.props.is12HourClock, this.props.currentTime)}
                    </span>
                </div>
                <div
                    style={{
                        ...this.styles.currentTimeLabelUnderLine,
                        left: this.props.timeLabelPosition
                    }}
                    pointerEvents="none"
                />
            </div>
        ) : (
            <div
                pointerEvents="none"
                key={key}
                style={{ ...style, ...this.styles.columnContainer }}
            >
                <span style={{ ...this.styles.text }}>{hours[index]}</span>
            </div>
        );
    };

    cellSizeAndPositionGetter = ({ index }) => {
        const hours = this.props.is12HourClock
            ? TIME_12H_30_MIN_INTERVALS
            : TIME_24H_30_MIN_INTERVALS;

        return index === hours.length
            ? {
                  height: 20,
                  width: 30,
                  x: this.props.timeLabelPosition,
                  y: 0
              }
            : {
                  height: this.props.theme.timeline.container.height,
                  width: 30 * this.props.theme.PIXELS_PER_MIN,
                  x: index * 30 * this.props.theme.PIXELS_PER_MIN,
                  y: 0
              };
    };

    render() {
        const {
            width,
            theme,
            timelineRef,
            showCurrentTime,
            timeLabelPosition,
            scrollLeft,
            is12HourClock
        } = this.props;
        const hours = is12HourClock ? TIME_12H_30_MIN_INTERVALS : TIME_24H_30_MIN_INTERVALS;
        return (
            <Collection
                style={{
                    overflow: 'hidden',
                    overflowX: 'hidden',
                    overflowY: 'hidden',
                    left: theme.sidebar.container.width,
                    right: 0,
                    top: 0
                }}
                cellCount={showCurrentTime ? hours.length + 1 : hours.length}
                cellRenderer={this.cellRenderer}
                cellSizeAndPositionGetter={this.cellSizeAndPositionGetter}
                height={theme.timeline.container.height}
                width={width}
                timeLabelPosition={timeLabelPosition}
                scrollLeft={scrollLeft}
                verticalOverscanSize={0}
                horizontalOverscanSize={0}
                ref={timelineRef}
            />
        );
    }

    styles = {
        text: {
            ...this.props.theme.timeline.text,
            textAlign: 'center',
            position: 'absolute',
            width: '100%',
            left: '-50%'
        },
        columnContainer: {
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            backgroundColor: this.props.theme.timeline.container.backgroundColor
        },
        currentTimeLabelContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            zIndex: 10,
            ...this.props.theme.currentTime.label
        },
        currentTimeLabelText: {
            textAlign: 'center',
            ...this.props.theme.currentTime.labelText
        },
        currentTimeLabelUnderLine: {
            position: 'absolute',
            backgroundColor: this.props.theme.currentTime.line.backgroundColor,
            width: this.props.theme.currentTime.line.width,
            bottom: 0,
            height: '50%',
            top: '50%'
        }
    };
}

Timeline.propTypes = {
    currentTime: PropTypes.instanceOf(Date),
    scrollLeft: PropTypes.number,
    showCurrentTime: PropTypes.bool,
    timeLabelPosition: PropTypes.number,
    timelineRef: PropTypes.func.isRequired,
    theme: PropTypes.object,
    width: PropTypes.number.isRequired
};

Timeline.defaultProps = {
    currentTime: new Date(),
    scrollLeft: null,
    showCurrentTime: false,
    timeLabelPosition: 0,
    theme: {}
};
